// "+ Produto novo" da tela Editar da tabela (Leva 2, spec 2026-09-29, 2.3):
// ao criar, volta para a tabela com o produto no topo. Sem preco ele espera em
// "Fora da tabela"; COM preco (teste dela 01/10) ja esta NA tabela, e volta em
// "Nesta tabela" -- "Fora" sem busca so mostra o recem-criado sem preco, e abria
// vazio. So aceita /tabelas/..., para o endereco nao virar um redirecionamento
// para qualquer lugar.
export function destinoAoCriarProduto(params: URLSearchParams, produtoId: string, entrouNaTabela = false): string {
  const voltar = params.get('voltar')
  if (!voltar || !/^\/tabelas\/[^/?#]+$/.test(voltar)) return '/produtos'
  const novo = `novo=${encodeURIComponent(produtoId)}`
  return entrouNaTabela ? `${voltar}?${novo}` : `${voltar}?filtro=fora&${novo}`
}
